<smw-background></smw-background>

<h1 class="title-lg mb-8">{{ '404_title' | translate }}</h1>
<p class="body-lg text-center mb-12" [innerHTML]="'404_message' | translate"></p>

<a smw-button kind="filled" [routerLink]="['collaborator.dashboard' | route]">{{ '404_action' | translate }}</a>
